const es = {
  nav: {
    inicio: 'Inicio',
    servicios: 'Servicios',
    galeria: 'Galeria',
    contacto: 'Contacto',
    cta: 'SOLICITAR COTIZACIÓN',
    ctaMobile: 'COTIZAR AHORA',
  },

  hero: {
    title: 'Control profesional de',
    titleHighlight: 'plagas',
    imgAlt: 'Sanitización Profesional',
    subtitle: 'Soluciones seguras para empresas, zonas residenciales y espacios especificos',
    subtitleBold: 'zonas residenciales y espacios especificos',
    techLine1: 'Tecnología de termonebulización',
    techLine2: '100% Biodegradable y libre de residuo tóxico.',
    cta: 'AGENDAR INSPECCIÓN',
  },

  services: {
    badge: 'Experticia Técnica',
    title: 'Nuestros',
    titleHighlight: 'servicios',
    description: 'Protocolos adaptados a cada necesidad, desde espacios domésticos hasta grandes instalaciones industriales en San Miguel de Allende, Irapuato, San Luis de la Paz y Dolores Hidalgo CIN.',
    cards: [
      {
        title: 'Programas Preventivos',
        desc: 'Planes personalizados para evitar infestaciones y asegurar continuidad operativa. Monitoreo constante con reportes detallados.',
        tag: 'Preventivo',
      },
      {
        title: 'Control en Casa',
        desc: 'Soluciones seguras y efectivas para el hogar. Productos de baja toxicidad aptos para familias y mascotas.',
        tag: 'Residencial',
      },
      {
        title: 'Habitaciones',
        desc: 'Tratamientos especializados para dormitorios y áreas privadas. Eliminación de chinches, ácaros y plagas nocturnas.',
        tag: 'Habitaciones',
      },
    ],
    customPlan: {
      title: '¿Necesitas un plan a medida?',
      desc: 'Diseñamos estrategias específicas basadas en el análisis de riesgo de tus instalaciones.',
      cta: 'Solicitar Auditoría',
    },
    sectorsBadge: 'Dónde trabajamos',
    sectorsTitle: 'Sectores que',
    sectorsTitleHighlight: 'servimos',
    sectors: [
      {
        title: 'Comedores',
        desc: 'Control riguroso para cocinas industriales y áreas de preparación de alimentos.',
      },
      {
        title: 'Almacenes',
        desc: 'Protección continua contra plagas en centros de distribución y logística.',
      },
      {
        title: 'Hoteles',
        desc: 'Ambientes seguros y libres de plagas para una experiencia de huésped impecable.',
      },
      {
        title: 'Habitaciones',
        desc: 'Tratamientos especializados para dormitorios y áreas privadas.',
      },
    ],
    activeLabel: 'Activo',
    trustBadgePrefix: 'Servicio disponible en',
    trustBadgeLocations: 'San Miguel de Allende, Irapuato, San Luis de la Paz y Dolores Hidalgo CIN',
  },

  gallery: {
    badge: 'Nuestro Trabajo',
    title: 'Soluciones Especializadas en Campo',
    viewImage: 'Ver imagen',
    close: 'Cerrar',
    images: [
      { title: 'Control en Escuelas', subtitle: 'Sanitización y control de plagas en instituciones educativas.' },
      { title: 'Control en Escuelas - Baños', subtitle: 'Tratamientos específicos para áreas sanitarias en escuelas.' },
      { title: 'Control en Escuelas - Comedor', subtitle: 'Garantía de higiene en establecimientos de alimentos.' },
      { title: 'Control en todo tipo de viviendas', subtitle: 'Soluciones integrales para hogares y residencias.' },
      { title: 'Control en todo tipo de viviendas', subtitle: 'Sanitización y control de plagas para espacios residenciales.' },
      { title: 'Control en todo tipo de viviendas', subtitle: 'Tratamientos especializados para patios y áreas exteriores.' },
      { title: 'Control en todo tipo de viviendas', subtitle: 'Tratamientos especializados para patios y áreas exteriores.' },
      { title: 'Control en todo tipo de viviendas', subtitle: 'Tratamientos especializados para patios y áreas exteriores.' },
    ],
  },

  contact: {
    badge: 'Contáctanos',
    title: 'Tu hogar, libre de',
    titleHighlight: 'plagas.',
    subtitle: 'Cuéntanos qué está pasando en tu casa o espacio y te damos solución. Atención rápida, productos seguros para tu familia y mascotas.',
    callLabel: 'Llámanos',
    emailLabel: 'Escríbenos',
    whatsappLabel: 'WhatsApp',
    whatsappValue: 'Chatea con nosotros',
    whatsappMessage: 'Hola, necesito ayuda con plagas en mi hogar',
    emergency: {
      title: '¿Urgencia en casa?',
      desc: 'Respondemos el mismo día. Sin importar si son cucarachas, ratones, chinches o cualquier otra plaga.',
      cta: 'Escribir por WhatsApp →',
      message: 'Tengo una urgencia con plagas',
    },
    form: {
      title: 'Solicita una visita de inspección',
      subtitle: 'Sin costo · Sin compromiso · Respuesta en menos de 24 hrs',
      name: 'Tu Nombre',
      namePlaceholder: 'Ej. María García',
      phone: 'Teléfono',
      phonePlaceholder: '+52 415 ...',
      email: 'Correo electrónico',
      emailPlaceholder: 'tu@correo.com',
      message: '¿Qué está pasando?',
      messagePlaceholder: 'Cuéntanos qué tipo de plaga tienes, en qué área de tu casa y desde cuándo...',
      submit: 'Solicitar Inspección',
      sending: 'Enviando...',
      success: '✓ ¡Listo! Te contactamos pronto.',
      privacy: 'Tu información es confidencial y nunca será compartida.',
    },
    location: {
      badge: 'Dónde estamos',
      mapTitle: 'Ubicación SaniPlagas',
      branchesLabel: 'Nuestras sucursales',
      mainBranch: 'Matriz',
      newBranch: 'Nueva sucursal',
      whatsappBranch: 'WhatsApp de esta sucursal',
      addressLabel: 'Dirección',
      scheduleLabel: 'Horario',
      scheduleValue: 'Todos los días, 24 horas',
      emergencies247: 'Emergencias 24/7',
      directions: 'Cómo llegar',
    },
  },

  // Landing dedicada de la sucursal Irapuato (/irapuato), usada como destino de Google Ads.
  irapuato: {
    metaTitle: 'Fumigación y Control de Plagas en Irapuato | SaniPlagas',
    metaDescription: 'Control de plagas profesional en Irapuato. Inspección sin costo, productos seguros para familia y mascotas, atención 24/7. Llámanos al 462 373 7003.',
    badge: 'Sucursal Irapuato',
    title: 'Control de plagas en',
    titleHighlight: 'Irapuato',
    subtitle: 'Nueva sucursal en Rincón de los Arcos. Inspección sin costo, productos de baja toxicidad y atención el mismo día.',
    ctaPrimary: 'AGENDAR INSPECCIÓN GRATIS',
    ctaCall: 'Llamar ahora',
    ctaWhatsapp: 'WhatsApp',
    trust: [
      { title: 'Inspección sin costo', desc: 'Vamos, revisamos y te cotizamos sin compromiso.' },
      { title: 'Atención 24/7', desc: 'Urgencias atendidas el mismo día en Irapuato y alrededores.' },
      { title: 'Seguro para tu familia', desc: 'Productos biodegradables, aptos con niños y mascotas.' },
      { title: 'Desde 2012', desc: 'Más de una década resolviendo plagas en el Bajío.' },
    ],
    servicesTitle: 'Qué resolvemos en Irapuato',
    servicesSubtitle: 'Casas, comercios, comedores, almacenes y hoteles. Tratamiento a la medida del problema.',
    formTitle: 'Agenda tu inspección en Irapuato',
    formSubtitle: 'Déjanos tus datos y te contactamos el mismo día.',
    locationTitle: 'Nuestra sucursal en Irapuato',
    backToSite: 'Ver el sitio completo',
  },

  footer: {
    bio: 'Control profesional de plagas en San Miguel de Allende e Irapuato. Certificados y listos 24/7.',
    navTitle: 'Navegación',
    servicios: 'Servicios',
    galeria: 'Galeria',
    contacto: 'Contacto',
    emergencyTitle: 'Emergencias',
    support247: 'Soporte 24/7 · Respuesta inmediata',
    privacyTerms: 'Privacidad & Términos',
    understood: 'Entendido',
    legalText: `AVISO DE PRIVACIDAD

saniplagasSA DE CV, comercialmente conocido como saniplagas, con domicilio en Alfil 22, INFONAVIT Malanquin, 37755 San Miguel de Allende, Gto., México, es el responsable del uso y protección de sus datos personales.

FINALIDADES PRIMARIAS
Los datos personales que recabamos de usted, los utilizaremos para las siguientes finalidades que son necesarias para el servicio que solicita:

• Respuesta a mensajes del formulario de contacto

FINALIDADES SECUNDARIAS
De manera adicional, utilizaremos su información personal para las siguientes finalidades secundarias que no son necesarias para el servicio solicitado, pero que nos permiten y facilitan brindarle una mejor atención:

• Mercadotecnia o publicidad

DATOS PERSONALES RECABADOS
Para las finalidades señaladas en el presente aviso de privacidad, podemos recabar sus datos de identificación y contacto.

DERECHOS ARCO
Usted tiene derecho a conocer qué datos personales tenemos de usted, para qué los utilizamos y las condiciones del uso que les damos (Acceso). Asimismo, es su derecho solicitar la corrección de su información personal en caso de que esté desactualizada, sea inexacta o incompleta (Rectificación); que la eliminemos de nuestros registros o bases de datos cuando considere que la misma no está siendo utilizada adecuadamente (Cancelación); así como oponerse al uso de sus datos personales para fines específicos (Oposición). Estos derechos se conocen como derechos ARCO.

Para el ejercicio de cualquiera de los derechos ARCO, usted deberá presentar la solicitud respectiva a través de contacto@saniplagas.mx. La respuesta a su solicitud será atendida en un plazo máximo de 5 días hábiles.

DATOS RECABADOS POR EL SITIO WEB
Nuestro sitio web recaba automáticamente los siguientes datos:

• Páginas web visitadas por un usuario
• Publicidad revisada por un usuario

CONTACTO
Para más información sobre este aviso de privacidad, puede contactarnos en:

Correo electrónico: contacto@saniplagas.mx
Sitio web: https://saniplagas.mx

Última actualización: 20/2/2026


TÉRMINOS DE USO
El uso de este sitio implica la aceptación de estos términos. El contenido es propiedad de SaniPlagas y no puede ser reproducido sin autorización. Los servicios están sujetos a disponibilidad en el área de San Miguel de Allende y zona metropolitana. SaniPlagas se reserva el derecho de modificar precios y condiciones sin previo aviso.

Para más información contacta a: contacto@saniplagas.mx`,
  },

  whatsapp: {
    tooltip: '¿Necesitas ayuda?',
    tooltipBold: '¡Escríbenos!',
    defaultMessage: 'Hola deseo cotizar un servicio',
  },

  a11y: {
    title: 'Accesibilidad',
    fontSize: 'Tamaño de texto',
    sizeNormal: 'Normal',
    sizeLarge: 'Grande',
    sizeXL: 'Extra grande',
    highContrast: 'Alto contraste',
    grayscale: 'Escala de grises',
    underlineLinks: 'Subrayar enlaces',
    readingGuide: 'Guía de lectura',
    reset: 'Restablecer',
    close: 'Cerrar panel de accesibilidad',
    open: 'Abrir opciones de accesibilidad',
    skipToContent: 'Ir al contenido principal',
  },
};

export default es;

